import { api } from "./client";

export const workItemsApi = {
  /** Dismiss a dead-lettered (failed) work item so it leaves the Inbox. */
  dismiss: (companyId: string, itemId: string) =>
    api.post<{ ok: true }>(
      `/companies/${companyId}/work-items/${itemId}/dismiss`,
      {},
    ),
};
